/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import  FastSafe  from "@/app/csr-src/assets/icons/FastSafe.svg";
import Styles from "./safetyLoading.module.scss";

const SafetyLoading = observer(() => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();
  return (
    <div className={Styles.safetyLoadingBox}>
      {checkoutStore.isQuickPay ? (
        <>
          <div className={Styles.imageBox}>
            <FastSafe width={60} height={60} />
          </div>
          <div className={Styles.safeTipsText}>{t("checkout.tips.fastSafe")}</div>
          <div className={Styles.loadingGif}></div>
        </>
      ) : (
        <>
          <div className={Styles.imageBox}>
            <div className={Styles.static}></div>
            <div className={Styles.loading}></div>
          </div>
          <div className={Styles.safeTipsText}>{t("checkout.tips.safe")}</div>
        </>
      )}
    </div>
  );
});

export default SafetyLoading;
